// File: App.tsx
import React, { FC, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import TestForm from './components/Form/FormFormik';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { callMsGraphSites, callMsGraphMe, getGroups } from './graph';
import { msalInstance } from './auth/authService';

interface GraphResponse<T> {
  value: T[];
}

const AppContent: FC = () => {
  const { isAuthenticated, accessToken, login, logout } = useAuth();
  const [siteData, setSiteData] = useState<any[] | null>(null);
  const [meData, setMeData] = useState<string | null>(null);
  const [groupsData, setGroupsData] = useState<any[]>([]);
  const [seniorManager, setSeniorManager] = useState<boolean>(false);
  const [siteManager, setSiteManager] = useState<boolean>(false);
  const [optionsReceived, setOptionsReceived] = useState<boolean>(false);

  // Fetch user, site, and group data when authenticated
  useEffect(() => {
    const fetchData = async () => {
      if (!accessToken) return;
      try {
        // fetch user display name
        const meRes = await callMsGraphMe(accessToken);
        setMeData(meRes.displayName);

        // fetch sites (assumes callMsGraphSites returns parsed JSON)
        const sitesRes = await callMsGraphSites(accessToken) as GraphResponse<any>;
        setSiteData(sitesRes.value);

        // fetch groups (assumes getGroups returns parsed JSON)
        const groupsRes = await getGroups(accessToken) as GraphResponse<any>;
        setGroupsData(groupsRes.value);
      } catch (e) {
        console.error('Error fetching Graph data:', e);
      }
    };

    if (isAuthenticated) {
      fetchData();
    }
  }, [isAuthenticated, accessToken]);

  // Set Account
  useEffect(() => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}, []);

  // Determine roles from group membership
  useEffect(() => {
    groupsData.forEach(group => {
      const id = group.id;
      if ([
        '6f6f75b6-312b-4369-8bbb-547478595d43',
        '83e8f23e-c3d7-4e31-ae0e-85936f6280f4',
        '5e8353dd-1ed0-419e-9b59-a5478a5fc222'
      ].includes(id)) {
        setSeniorManager(true);
        setOptionsReceived(true);
        console.log("!! Senior Manager !!")
      }
      if (id === 'ca555000-267f-4b54-9f1e-2585385880b4') {
        setSiteManager(true);
        console.log("!! Site Manager !!")
      }
    });
  }, [groupsData]);

  if (!isAuthenticated) {
    return (
      <Container className="my-4 p-4 rounded-xl bg-offWhite text-center">
        <h1 className="text-gray-700 text-3xl my-4">Maxi Construction</h1>
        <h2 className="text-gray-700 text-3xl my-4">SMSIR</h2>
        <button onClick={login} className="btn btn-primary">
          Sign In
        </button>
      </Container>
    );
  }

  return (
    <Container className="my-4 p-4 rounded-xl bg-offWhite mx-auto">
      <h1 className="text-gray-700 text-3xl text-center my-4">Maxi Construction</h1>
      <h2 className="text-gray-700 text-3xl text-center my-4">
        Self Monitoring Site Inspection Report
      </h2>
      <div className='text-center'>
        <button onClick={logout} className="btn btn-secondary mb-4">
          Sign Out
        </button>
      </div>
      {siteData && meData && (
        <TestForm
          siteData={siteData}
          meData={meData}
          optionsData={optionsReceived}
          androidAccessToken={accessToken}
          siteManager={siteManager}
          seniorManager={seniorManager}
        />
      )}
    </Container>
  );
};

const App: FC = () => (
  <AuthProvider>
    <AppContent />
  </AuthProvider>
);

export default App;
